import { getGasAbstractionFeeSubtitle } from "../utils/gasAbstractionFeeLabel.js";

function normalizeLanguage(language) {
  return language === "en" ? "en" : "de";
}

/**
 * Friendly display for the internal `gas_abstraction_fee` classification.
 * The paymaster sponsors the native VTHO network gas while the wallet pays
 * the displayed VIP-180/VET token amount to the paymaster.
 */
export default function GasAbstractionFeeLabel({
  language = "de",
  className = "",
}) {
  const lang = normalizeLanguage(language);
  const title = "Gas Payment";
  const subtitle = getGasAbstractionFeeSubtitle();
  const tooltip =
    lang === "en"
      ? "VIP-191 fee delegation: the paymaster covers the native VTHO network gas; this row is the token fee paid by the wallet."
      : "VIP-191 Fee Delegation: Der Paymaster übernimmt das native VTHO-Netzwerk-Gas; diese Zeile ist die von der Wallet bezahlte Token-Gebühr.";

  return (
    <div
      className={`flex items-start gap-1.5 text-orange-700 min-w-0 ${className}`.trim()}
      title={tooltip}
    >
      <span className="mt-px flex-shrink-0" aria-hidden>
        ⚡
      </span>
      <div className="min-w-0 leading-tight">
        <div className="whitespace-normal break-words font-semibold">{title}</div>
        <div className="whitespace-normal break-words text-[11px] font-medium text-orange-700/80">
          {subtitle}
        </div>
      </div>
    </div>
  );
}
